import Wynyard91 from '../../../Media/BSD/Hiera/Wynyard 9.webp'
import Wynyard92 from '../../../Media/BSD/Hiera/Wynyard 9.webp'





const Wynyard9images =[
Wynyard91,Wynyard92
]

export default Wynyard9images;